// extracted by mini-css-extract-plugin
export default {"cls1":"xneT3OwWlFGYHF34urHo","cls2":"cIZiYenxZjN7GAtaU6gY xneT3OwWlFGYHF34urHo","isSelected":"q1CnaLbVyOi2E9XDYAym"};